export { default as SalePage } from "./View";
export { default as PageSale } from "./Page";